import { usersApi } from "./usersApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreateUser, UpdateUser, Users } from "./users.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";


export const fetchUsers = createAsyncThunk<
  APIResponse<Users[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'users/fetchUsers',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        usersApi.endpoints.getUsers.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Usuarios',
          details: data.details
        });
    }
  }
);


export const fetchUserById = createAsyncThunk<APIResponse<Users>, string,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'users/fetchUsersById',
  async (id: string, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        usersApi.endpoints.getUserById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Usuario por ID',
        details: data.details
      });
    }
  }
);


export const createUser = createAsyncThunk<APIResponse<Users>, CreateUser,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'users/createUser',
  async (data: CreateUser, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        usersApi.endpoints.createUser.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Usuario',
        details: data.details
      });
    }
  }
);



export const updateUser = createAsyncThunk<
  APIResponse<Users>,
   { id: string; changes: UpdateUser }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'users/updateUser',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        usersApi.endpoints.updateUser.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Usuario',
        details: data.details
      });
    }
  }
);


export const deleteUser = createAsyncThunk<
  string,
  string,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'users/deleteUser',
  async (id , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        usersApi.endpoints.deleteUser.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al eliminar Usuario',
        details: data.details
      });
    }
  }
);